import type { LucideIcon } from 'lucide-react'

type ServiceCardProps = {
  bestFor: string
  description: string
  icon: LucideIcon
  index: number
  outputs: string[]
  title: string
}

export function ServiceCard({ bestFor, description, icon: Icon, index, outputs, title }: ServiceCardProps) {
  const headingId = `service-card-${index}`

  return (
    <article
      aria-labelledby={headingId}
      className="glass-card relative flex h-full flex-col overflow-hidden p-5 transition-colors duration-150 hover:border-[rgba(102,58,243,0.45)]"
    >
      <div className="flex flex-1 items-start gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-primary/40 bg-primary/15 text-primary-foreground">
          <Icon aria-hidden="true" className="h-5 w-5" />
        </div>
        <div>
          <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <p className="font-mono text-xs text-whisper-blue">{String(index + 1).padStart(2, '0')}</p>
            <h2 className="text-lg font-semibold text-comet" id={headingId}>
              {title}
            </h2>
          </div>
          <p className="mt-3 text-sm leading-7 text-arctic-mist">{description}</p>
        </div>
      </div>
      <div className="mt-5 border-t border-[var(--border)] pt-4">
        <p className="text-sm font-medium text-celestial-light">{bestFor}</p>
        <ul className="mt-4 grid gap-2 text-sm text-arctic-mist">
          {outputs.map((output) => (
            <li key={output} className="border-l border-[var(--border)] pl-3">
              {output}
            </li>
          ))}
        </ul>
      </div>
    </article>
  )
}
